module.exports = __webpack_public_path__ + "media/application/images/icons/icon-bulb-ff8beecac71cd4da7707a95ed09e0ea8.svg";